export default __webpack_public_path__ + "static/media/img_demo_01.5026b091.jpg";